import React from "react";
import BarCode from "assets/images/icons/barcode.svg";
import * as S from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import PayCar from "assets/images/icons/gray-car-circle.svg";
import InfoFrameImage from "assets/images/icons/briefcase-business.svg";
import usePayment from "hooks/usePayment";
import { useWhitelabel } from "hooks/useWhitelabel";

export const ButtonsStartInstallment: React.FC = () => {
  const navigate = useNavigate();
  const { id_usuario } = useParams();
  const { clearPaymentBilletData } = usePayment();
  const { services } = useWhitelabel();
  const {
    pay_billet_installments,
    label_pay_billet_installments,
    description_pay_billet_installments,
    // pay_taxes,
    // label_pay_taxes,
    // description_pay_taxes,
    pay_vehicle_debts,
    label_pay_vehicle_debts,
    description_pay_vehicle_debts,
    transfer_bank,
    label_transfer_bank,
    description_transfer_bank,
    pay_public_departments_debts,
    label_pay_public_departments_debts,
    description_pay_public_departments_debts,
  } = services;

  const navigateToPartner = (isPublicDepartment = false) => {
    clearPaymentBilletData();
    let url = "/parceiro";
    if (id_usuario) {
      url += `/${id_usuario}`;
    }
    if (isPublicDepartment) {
      url += "?public_department=SBC";
    }
    navigate(url);
  };

  return (
    <S.Container>
      <S.WrapperContainer>
        {pay_billet_installments ? (
          <S.ButtonLeft
            data-testid="start-billet-button"
            onClick={() =>
              navigate(id_usuario ? `/boleto/${id_usuario}` : "/boleto")
            }
            style={{ minHeight: "136px" }}
          >
            <S.RowIconTitleButton>
              <S.IconButton src={BarCode} />
              <S.TitleButton>{label_pay_billet_installments}</S.TitleButton>
            </S.RowIconTitleButton>
            <S.SubTitleButton>
              {description_pay_billet_installments}
            </S.SubTitleButton>
          </S.ButtonLeft>
        ) : null}

        {transfer_bank ? (
          <S.ButtonLeft
            onClick={() =>
              navigate(
                id_usuario ? `/transferencia/${id_usuario}` : "/transferencia"
              )
            }
            style={{ minHeight: "136px" }}
          >
            <S.RowIconTitleButton>
              <S.IconButton src={BarCode} />
              <S.TitleButton>{label_transfer_bank}</S.TitleButton>
            </S.RowIconTitleButton>
            <S.SubTitleButton>{description_transfer_bank}</S.SubTitleButton>
          </S.ButtonLeft>
        ) : null}

        {pay_vehicle_debts ? (
          <S.ButtonLeft
            data-testid="start-vehicle-debts-button"
            onClick={() => navigateToPartner()}
            style={{ minHeight: "136px" }}
          >
            <S.RowIconTitleButton>
              <S.IconButton src={PayCar} />
              <S.TitleButton>{label_pay_vehicle_debts}</S.TitleButton>
            </S.RowIconTitleButton>
            <S.SubTitleButton>{description_pay_vehicle_debts}</S.SubTitleButton>
          </S.ButtonLeft>
        ) : null}

        {pay_public_departments_debts ? (
          <S.ButtonLeft
            onClick={() => navigateToPartner(true)}
            style={{ minHeight: "136px" }}
          >
            <S.RowIconTitleButton>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    width: 45,
                    height: 45,
                    borderRadius: "50%",
                    backgroundColor: "#e9e9e9",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img src={InfoFrameImage} alt="info" style={{ width: 23, height: 23 }} />
                </div>
            </div>
              <S.TitleButton>{label_pay_public_departments_debts}</S.TitleButton>
            </S.RowIconTitleButton>
            <S.SubTitleButton>{description_pay_public_departments_debts}</S.SubTitleButton>
          </S.ButtonLeft>
        ) : null}
      </S.WrapperContainer>

      <S.WrapperContainer>
        {/* {pay_taxes ? (
          <a
            href="https://portal.parcelamostudo.com.br/payment_online/parceiros?is_tax=true"
            target="_blank"
            rel="noreferrer"
          >
            <S.ButtonRight>
              <S.RowIconTitleButton>
                <S.IconButton src={Tax} />
                <S.TitleButton>{label_pay_taxes}</S.TitleButton>
              </S.RowIconTitleButton>
              <S.SubTitleButton>{description_pay_taxes}</S.SubTitleButton>
            </S.ButtonRight>
          </a>
        ) : null} */}

        {/* <S.ButtonRight>
          <S.RowIconTitleButton>
            <S.IconButton src={RechargePhone} />
            <S.TitleButton>Recarregar celular</S.TitleButton>
          </S.RowIconTitleButton>
          <S.SubTitleButton>
            Recarregue seu telefone e pague parcelado.
          </S.SubTitleButton>
        </S.ButtonRight> */}
      </S.WrapperContainer>
    </S.Container>
  );
};
